import styled from '@emotion/styled';
import { BG_BLUE } from 'constants/theme';

const SidebarSectionTitle = styled('h2')`
  font-size: 16px;
  margin-bottom: 8px;
  color: ${BG_BLUE};
  font-family: ${({ theme }) => theme.fonts.soehneBuch};

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export default SidebarSectionTitle;
